<main id="main" class="main">
  <div class="row paddingHeader">
    <div class="col-12 col-md-12 d-flex justify-content-between" style="background: #5d7c9b!important; font-size:14px">
      <h6 class="admintitle my-auto">
        {{lang.Members}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
      </h6>
      <button (click)="openModelAddMumber()" class="addCustomer my-auto">+&nbsp;{{lang.Add_New}}</button>


    </div>
  </div>




  <div class="row mt-4" [ngStyle]="{'display': showfilter ? 'block' : 'none'}">
    <div class="row filterByStatus mt-1" *ngIf="!loader">
      <div class="col-12 col-md-6 ">
        <label for="" style="font-size: 14px;font-family:'sans-serif' ;">{{lang.Filter_by_Status}}:&nbsp;</label>
      </div>
      <div class="col-md-6 p-0">
        <select name="" id="" class="form-select form-select-sm" (change)="changeStatus($event)">
          <option value="all">{{lang.All}}</option>
          <option *ngFor="let status of filterStatus" [value]="status">{{status}}</option>

        </select>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="table-responsive">
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="DataTables_Table_0"
        class="table text-nowrap">
        <thead>
          <tr>
            <!-- <th>S.no</th> -->
            <th></th>
            <th>{{lang.IGBMS_Id}}</th>
            <th>{{lang.Type}}</th>
            <th>{{lang.Name}}</th>
            <th>{{lang.Email}}</th>
            <th>{{lang.Phone}}</th>
            <th>{{lang.Registration_Date}}</th>
            <th>{{lang.Status}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let client of members; let i = index">
            <!-- <td>{{i+1}}</td> -->
            <td class="my-auto">
              <i *ngIf="client.bulkPlanIncluded" class=""
                style="font-size:14px;color:rgb(31, 31, 29);font-family: system-ui;font-weight: 600;"
                title="Bulk/Group Plan Member">B</i>
              <i *ngIf="client.greenshieldMemberId || client.greenshieldRegistrationStatus"
                style="font-size:14px;color:green;font-family: system-ui;font-weight: 600;"
                title="Greenshield Member">G</i>
              <i *ngIf="client.equitableCertificateId || client.equitableRegistrationStatus"
                style="font-size:14px;color:#2762b9;font-family: system-ui;font-weight: 600;"
                title="Equitable Member">E</i>
              <!-- <i *ngIf="client.equitableCertificateId || client.equitableRegistrationStatus"
                style="font-size:14px;color:#2762b9;font-family: system-ui;font-weight: 600;" title="Equitable Member">W</i> -->
            </td>
            <td>{{client.fusebillCustomerId}} </td>
            <td>{{client.isCorporateAccount?'CORP':'GIG'}}</td>
            <td (click)="showDetails(client)" style="cursor: pointer;"><span class="viewCorporate"
                data-bs-target="#memberdetails" data-bs-toggle="modal">{{client.firstName | titlecase}}
                {{client.lastName |titlecase}}</span></td>
            <td>{{client.user?.username??''}}</td>
            <ng-template [ngIf]="client?.contactInformations==undefiend" [ngIfElse]="contactInformations">
              <td></td>
            </ng-template>
            <ng-template #contactInformations>
              <td>{{client?.contactInformations[0]?.primaryPhone??''}}</td>
            </ng-template>

            <ng-template [ngIf]="client?.registrationDate?.includes('00-00')??true" [ngIfElse]="registrationDate">
              <td></td>
            </ng-template>
            <ng-template #registrationDate>
              <td> {{client?.registrationDate | date: 'MM/dd/yyyy' }}</td>
            </ng-template>
            <td>
              <!-- <select class="form-control1" id="gender" [(ngModel)]="client.status"
              [ngModelOptions]="{standalone: true}" placeholder="Select"
              (change)="brokerStatus(client,brokerstatus.value,i)" #brokerstatus>

              <option value="Active"> Active </option>
              <option value="Draft"> Draft </option>
              <option value="Suspended"> Suspended </option>
              <option value="Cancelled"> Cancelled </option>
              <option value="Incomplete"> Incomplete </option>


            </select> -->
              <!-- [style.color]="client.status=== ? 'green' : 'red'" -->




              <span class="brokertablestatus mx-1 text-center" *ngIf="client.status!='Cancelled'">{{client.status }}</span>
              <span class="brokertablestatusCanclled mx-1 text-center" *ngIf="client.status=='Cancelled'" title={{client.terminationReason}}>{{client.status }} <span *ngIf="client.terminationDate!=null">on {{client.terminationDate | date}}</span></span>
            </td>

            <!-- <td>
        <button class="brokertablestatus" *ngIf="client.status==false" style="color:red">Inactive</button>
        <button class="brokertablestatus" *ngIf="client.status==true" style="color:green">Active</button>
      </td> -->
            <td class="d-flex justify-content-end">
              <div style="min-width: 20px;" data-bs-target="showmemberlist">
                <a *ngIf="(client.status=='Active' || client.status=='Draft') && (role==='ADMINISTRATOR' || role==='BROKER')"
                  class="viewicon" title="Terminate" data-toggle="tooltip" style="cursor: pointer;"><i
                    class="fa fa-trash-o pe-1" style="color:red; font-size:15px"
                    (click)="terminatemember(client,i)"></i></a>&nbsp;
              </div>
              <div style="min-width: 20px;">
                <a class="viewicon" *ngIf="client.status=='Active' && client.bulkPlanIncluded!=true" title="Send Invite"
                  data-toggle="tooltip">
                  <!-- fa fa-send-o -->
                  <i class="fa fa-send-o cursor: pointer;" style="color:rgb(56,76,159);cursor: pointer;"
                    (click)="invitationMail(client)">
                  </i></a>&nbsp;
              </div>




              <!-- <a class="deleteicon" title="Delete" data-toggle="tooltip" ><i class="bi bi-trash-fill" *ngIf="role=='ADMINISTRATOR'" (click)="deletebrokerDetails(client,i)"></i></a>&nbsp; -->
              <!-- <a class="deleteicon" title="Send Invite" data-toggle="tooltip" ><i class="fa fa-paper-plane" style="color: rgb(56,76,159);" *ngIf="role=='ADMINISTRATOR'" (click)="invitationbroker(client,i)"></i></a>&nbsp; -->

            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


</main>



<div class="modal" id="showmemberlist" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span class="modal-title">{{lang.Terminate}}&nbsp;&nbsp;<b>{{emplomentFirstName}}&nbsp;{{emplomentLastName}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="model-body">
        <form class="onbordingform" [formGroup]="terminationform">
          <div class="row">
            <div class="col-12 col-md-7">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Please_choose_Termination_Date}}</label>
                <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field"
                  formControlName="terminationDate" [minDate]="minDate" bsDatepicker
                  value="{{ terminationDateValue | date: 'MM-dd-YYYY'}}" [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"
                  [(bsValue)]="terminationDateValue" [(ngModel)]="terminationDateValue" />
                <div class="help-block text-danger" *ngIf="terminationform.get('terminationDate')?.touched ">
                  <div *ngIf="terminationform.get('terminationDate')?.hasError('required') ||
                (terminationform.get('terminationDate')?.hasError('required'))"> {{lang.Please_Select_Date}}</div>

                </div>
              </div>


              <p *ngIf="role==='ADMINISTRATOR'" style="font-size:10px">{{lang.Plan_enrollment_date_is}}-{{enroll
                |date:'MM-dd-YYYY'}}<br>{{note}}
              </p>

              <!-- data-toggle="tooltip "
              title="Note: Administrators can select a termination date up to 3 months in the past. However, if the plan's enrollment
              date is in the past, the termination date can only be set up to the enrollment date. If the enrollment date is in the
              future,today's date will be the earliest possible selection." -->
            </div>
          </div>
        </form>

      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closeTerminatePopup('showmemberlist')">
          {{lang.Close}}
        </button>
        <button class="text-end" type="submit" class="btn btn-primary personalinfobutton" (click)="submittermination()">
          {{lang.Submit}}&nbsp;&nbsp;
        </button>
        <!-- <button type="button" class="btn btn-secondary btn-light" id="updateButton" (click)="submittermination()" ><b>Submit</b></button>&nbsp;&nbsp; -->

      </div>
    </div>
  </div>
</div>

<div class="modal" id="showTerminateMemberDetails" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered " id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">

      <div class="modal-header" id="backgroundColor">
        <span
          class="modal-title py-2">{{lang.Terminate}}&nbsp;&nbsp;<b>{{emplomentFirstName}}&nbsp;{{emplomentLastName}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="model-body" style="font-family: sans-serif;">
        <form class="onbordingform" [formGroup]="terminationformDetails">

          <div>

            <div class="row ">
              <div class="col-md-6 pt-2">
                <label>{{lang.Customer_Type}}: {{terminateMemberDetails?.customerType }}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.IGBMS_Id}}: {{terminateMemberDetails?.staxbillDetails?.id }}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.Plan_Enrollment_Date}}: {{ terminateMemberDetails?.enrollmentDate}}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.Termination_Date}}: {{terminateMemberDetails?.terminationDate}}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.Service_Type}}:
                  {{terminateMemberDetails?.servicesType.length<=0 ? 'N/A' :
                    terminateMemberDetails?.servicesType?.join(', ') | titlecase}}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.Monthly_Premium}}:
                  {{terminateMemberDetails?.monthlyRecurringAmount==0?"$0":"$"+terminateMemberDetails?.monthlyRecurringAmount}}</label>
              </div>

            </div>
            <div class="row pt-2">

              <div class="col-md-12">
                <label>{{lang.Refund_Details}}
                </label>
              </div>

              <div *ngIf="!isDisabled()" class="col-md-6 pt-2 ">
                <div>
                  <label> Refund Applicable<span class="text-danger">*</span></label>
                </div>

                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" name="proceedWithRefund"
                    id="proceedWithRefundYes" [value]=true formControlName="proceedWithRefund"  />
                  <label class="form-check-label" for="proceedWithRefundYes">
                    Yes</label>
                </div>
                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" [value]=false name="proceedWithRefund"
                    id="proceedWithRefundNo" formControlName="proceedWithRefund" />
                  <label class="form-check-label" for="proceedWithRefundNo">No</label>
                </div>


              </div>


              <div *ngIf="isDisabled()" class="col-md-6 pt-2 ">
                <div>
                  <label> Refund Applicable<span class="text-danger">*</span></label>
                </div>

                <div class="form-check form-check-inline col-3">
                  <input disabled class="form-check-input border border-dark" type="radio" name="proceedWithRefund"
                    id="proceedWithRefundYes" [value]=true formControlName="proceedWithRefund"  />
                  <label class="form-check-label" for="proceedWithRefundYes">
                    Yes</label>
                </div>
                <div class="form-check form-check-inline col-3">
                  <input disabled class="form-check-input border border-dark" type="radio" [value]=false name="proceedWithRefund"
                    id="proceedWithRefundNo" formControlName="proceedWithRefund" />
                  <label class="form-check-label" for="proceedWithRefundNo">No</label>
                </div>


              </div>



              <div class="col-md-6 pt-2 ">
                <label>{{lang.Refund_Applicable}}:
                    <input *ngIf="!isDisabled()" type="text" class="form-control border border-dark"
                    placeholder="Please enter actual refund amount" formControlName="refundAmount" />

                    <input *ngIf="isDisabled()" disabled type="text" class="form-control border border-dark"
                    placeholder="Please enter actual refund amount" formControlName="refundAmount" />
                  </label>
              </div>

              <!-- <div class="col-md-6 pt-2 ">
                <label>Refund Applicabsle:
                  {{staxbillDetails?.refundApplicable==false?' No':'Yes'}}</label>
              </div> -->
              <div class="col-md-6 pt-2">
                <label>{{lang.Payment_Method}}:
                  {{terminateMemberDetails?.paymentMethod}}</label>
              </div>
              <!-- <div class="col-md-6 pt-2 ">
                <label>{{lang.Refund_Actual_Amount}}:
                  {{staxbillDetails?.refundAmount=='NA'?"N/A":'$ ' +staxbillDetails?.refundAmount}}</label>
              </div> -->
              <div class="col-md-6 pt-2 ">
                <label>{{lang.Refund_Based_on_Payments}}:
                  $ {{terminateMemberDetails?.refundAmountbasedOnPayments}}</label>
              </div>

            </div>
          </div>

          <div class="row  px-2 mt-2" *ngIf="terminateMemberDetails?.invoiceAndRefunds.length>0">

            <table align="left">
              <tr>
                <th class="my-auto" style="background: #5d7c9b !important; ">{{lang.Invoice_Id}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Invoice_Number}}</th>
                <th class="text-center" style="background: #5d7c9b !important; ">{{lang.Amount}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Date}}</th>
                <th style="background: #5d7c9b !important; ">{{Payment_Status}}</th>
                <th style="background: #5d7c9b !important; ">{{Refund_Applicable}}</th>
              </tr>
              <tbody>
                <tr *ngFor="let invoice of terminateMemberDetails.invoiceAndRefunds">
                  <td>{{invoice.id}}</td>
                  <td>{{invoice.invoiceNumber}}</td>
                  <td class="text-center">$ {{invoice.invoiceAmount | number : "1.2-2"}}</td>
                  <td>{{invoice.postedTimestamp|date: 'MM-dd-YYYY'}}</td>
                  <td>{{invoice?.paymentStatus}}</td>
                  <td>{{invoice?.refundApplicable ===false?'No':'Yes'}}</td>
                </tr>
              </tbody>
            </table>

          </div>

          <!-- Refund table -->
          <!-- <div class="row">
            <table align="left">
              <tr>
                <th>Refund Applicable</th>
                <th>Refund Amount</th>
                <th>Note</th>
              </tr>
              <tbody>
                <tr>
                  <td>{{staxbillDetails?.refundApplicable==false?'None':staxbillDetails?.refundApplicable}}</td>
                  <td>{{staxbillDetails?.refundAmount=='NA'?"N/A":staxbillDetails?.refundAmount}}</td>
                  <td>{{staxbillDetails?.cancelCustomerNotes}}</td>
                </tr>
              </tbody>
            </table>
            <div class="row">


              <div class="form-group col-12 col-md-6" id="box">
                <div class="col-12">
                  <label for=""> Proceed With Cancel Customer<span class="text-danger">*</span></label>
                </div>

                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" name="proceedWithCancelCustomer"
                    id="proceedWithCancelCustomerYes" [value]=true formControlName="proceedWithCancelCustomer" />
                  <label class="form-check-label" for="proceedWithCancelCustomerYes">
                    Yes</label>
                </div>
                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" [value]=false
                    name="proceedWithCancelCustomer" id="proceedWithCancelCustomerNo"
                    formControlName="proceedWithCancelCustomer" />
                  <label class="form-check-label" for="proceedWithCancelCustomerNo">No</label>
                </div>

              </div>
            </div>
            <div class="row" *ngIf="staxbillDetails?.refundApplicable">
              <div class="form-group col-12 col-md-6" id="box">
                <div class="col-12">
                  <label for=""> Proceed With Subscription Expiry<span class="text-danger">*</span></label>
                </div>

                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" name="proceedWithSubscriptionExpiry"
                    id="proceedWithSubscriptionExpiryYes" [value]=true
                    formControlName="proceedWithSubscriptionExpiry" />
                  <label class="form-check-label" for="proceedWithSubscriptionExpiryYes">
                    Yes</label>
                </div>
                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" [value]=false
                    name="proceedWithSubscriptionExpiry" id="proceedWithSubscriptionExpiryNo"
                    formControlName="proceedWithSubscriptionExpiry" />
                  <label class="form-check-label" for="proceedWithSubscriptionExpiryNo">No</label>
                </div>

              </div>


            </div>
            <div class="row" *ngIf="staxbillDetails?.refundApplicable">
              <div class="form-group col-12 col-md-6" id="box">
                <div class="col-12">
                  <label for=""> Proceed With Refund<span class="text-danger">*</span></label>
                </div>

                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" name="proceedWithRefund"
                    id="proceedWithRefundYes" [value]=true formControlName="proceedWithRefund" />
                  <label class="form-check-label" for="proceedWithRefundYes">
                    Yes</label>
                </div>
                <div class="form-check form-check-inline col-3">
                  <input class="form-check-input border border-dark" type="radio" [value]=false name="proceedWithRefund"
                    id="proceedWithRefundNo" formControlName="proceedWithRefund" />
                  <label class="form-check-label" for="proceedWithRefundNo">No</label>
                </div>

              </div>
            </div>
          </div> -->

          <!-- table -->
          <div class="row px-2 mt-2"
            *ngIf="terminateMemberDetails?.serviceType.length>0 && terminateMemberDetails?.terminationsProvisioning.length>0">
            <table align="left" style="background: #5d7c9b !important; ">
              <tr>
                <th class="my-auto" style="background: #5d7c9b !important; ">{{lang.Service}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Name}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Policy}}</th>
                <th style="width:175px ;background: #5d7c9b !important;">{{lang.Effective_Termination_Date}}</th>
                <th style="width:100px ;background: #5d7c9b !important;">{{lang.Membership_Id}}</th>
                <th style="width:200px ;background: #5d7c9b !important; ">{{lang.Action}}</th>
              </tr>
              <tbody>

                <tr class=" my-auto bg-white" *ngFor="let item of terminationsProvisioning ; let index=index">
                  <td>{{item?.serviceType}}</td>
                  <td>{{item?.service}}</td>
                  <td>{{item?.policy}}</td>
                  <td>{{item?.date}}<br><small>{{item.description}}</small></td>
                  <td>{{item?.membershipId}}</td>
                  <td>

                    <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showEquitable">
                      <div class="col-12">
                        <label for=""> {{lang.Proceed_With_Equitable}}<span class="text-danger">*</span></label>
                      </div>

                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" name="proceedWithEquitable"
                          id="proceedWithEquitableYes" [value]=true formControlName="proceedWithEquitable" />
                        <label class="form-check-label" for="proceedWithEquitableYes">
                          {{lang.Yes}}</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" [value]=false
                          name="proceedWithEquitable" id="proceedWithEquitableNo"
                          formControlName="proceedWithEquitable" />
                        <label class="form-check-label" for="proceedWithEquitableNo">{{lang.No}}</label>
                      </div>

                    </div>

                    <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showSmartchoice">
                      <div class="col-12">
                        <label for=""> {{lang.Proceed_With_Smartchoice}}<span class="text-danger">*</span></label>
                      </div>

                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" name="proceedWithSmartchoice"
                          id="proceedWithSmartchoiceYes" [value]=true formControlName="proceedWithSmartchoice" />
                        <label class="form-check-label" for="proceedWithSmartchoiceYes">
                          {{lang.Yes}}</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" [value]=false
                          name="proceedWithSmartchoice" id="proceedWithSmartchoiceNo"
                          formControlName="proceedWithSmartchoice" />
                        <label class="form-check-label" for="proceedWithSmartchoiceNo">{{lang.No}}</label>
                      </div>

                    </div>
                    <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showGreenshield">
                      <div class="col-12">
                        <label for=""> {{lang.Proceed_With_Greenshield}}<span class="text-danger">*</span></label>
                      </div>

                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" name="proceedWithGreenshield"
                          id="proceedWithGreenshieldYes" [value]=true [disabled]="!item?.membershipId"
                          formControlName="proceedWithGreenshield" />
                        <label class="form-check-label" for="proceedWithGreenshieldYes">
                          {{lang.Yes}}</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" [value]=false
                          name="proceedWithGreenshield" [disabled]="!item?.membershipId" id="proceedWithGreenshieldNo"
                          formControlName="proceedWithGreenshield" />
                        <label class="form-check-label" for="proceedWithGreenshieldNo">{{lang.No}}</label>
                      </div>

                    </div>
                    <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showPHR">
                      <div class="col-12">
                        <label for=""> {{lang.Proceed_With_PHR}}<span class="text-danger">*</span></label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" name="proceedWithPHR"
                          id="proceedWithPHRYes" [value]=true [disabled]="!item?.membershipId"
                          formControlName="proceedWithPHR" />
                        <label class="form-check-label" for="proceedWithPHRYes">
                          {{lang.Yes}}</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" [value]=false
                          name="proceedWithPHR" [disabled]="!item?.membershipId" id="proceedWithPHRNo"
                          formControlName="proceedWithPHR" />
                        <label class="form-check-label" for="proceedWithPHRNo">{{lang.No}}</label>
                      </div>

                    </div>
                  </td>

                </tr>

              </tbody>

            </table>

          </div>

          <div class="row" *ngIf="terminateReasonsApplicable">
            <div class="col-12 col-md-6 pb-2">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Reason}}</label>

                <select class="form-control select2" id="parentidrole" placeholder="Select" formControlName="reason"
                  data-live-search="true">
                  <option value="" label="" disabled>{{lang.Select}}</option>
                  <option value="" *ngFor="let reson of terminateReasonsWithKeys" [value]="reson.key">
                    {{reson.display}}</option>
                </select>

              </div>
            </div>
          </div>

        </form>

      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closeModelPopup('showTerminateMemberDetails')">
          {{lang.Cancel}}
        </button>
        <button class="text-end" type="submit" class="btn btn-primary personalinfobutton"
          (click)="submitterminationEnd()">
          {{lang.Terminate}}&nbsp;&nbsp;
        </button>

      </div>
    </div>
  </div>
</div>
<app-add-customer id="openModelAddMumber" [valuFormChaild]="valuFormChaild" class="modal fade"
  data-bs-backdrop="static">
</app-add-customer>

<app-confirmation-dialog [message]="message" [languageData]="languageData" *ngIf="languageData">
</app-confirmation-dialog>
<!-- app-overview -->

<!-- <app-overview class="modal fade" *ngIf="showmemberData" id="memberdetails" [customerIdOfMember]="customerId" [popupDisplay]="popupDisplay"   data-bs-backdrop="static">
</app-overview> -->

<!-- <app-overview *ngIf="showmemberData" id="memberdetails" class="modal fade"  data-bs-backdrop="static">
</app-overview> -->
